import CustomEditor from "./custom-editor.component";

export default CustomEditor;
